import { useMemo, useState } from "react";
import { ChevronLeft, ChevronRight, RotateCcw } from "lucide-react";
import QuestionCard from "../components/QuestionCard";
import AnswerButtons from "../components/AnswerButtons";
import PageWrapper from "./PageWrapper";

const PREVIEW_QUESTIONS = [
  {
    id: "preview-discovery",
    text: "Lequel de nous deux survivrait le mieux à une apocalypse zombie ?",
    category: "DISCOVERY",
    intensity: 1,
    format: "CHOICE",
    options: [
      { value: "choice_a", label: "TheGualdo" },
      { value: "choice_b", label: "La Fée Paschier" },
      { value: "choice_both", label: "Tous les deux" },
    ],
  },
  {
    id: "preview-personal",
    text: "Tu préfères avoir des bras de 3 mètres ou les yeux sous les fesses ?",
    category: "PERSONAL",
    intensity: 2,
    format: "CHOICE",
    options: [
      { value: "choice_a", label: "Avoir des bras de 3 mètres" },
      { value: "choice_b", label: "Avoir les yeux sous les fesses" },
      { value: "choice_both", label: "Je refuse de choisir" },
    ],
  },
  {
    id: "preview-intimate",
    text: "Est-ce que le regard de quelqu'un peut suffire à créer de l'attirance pour toi ?",
    category: "INTIMATE",
    intensity: 3,
    format: "STANDARD",
  },
  {
    id: "preview-spicy",
    text: "L'idée d'un endroit inhabituel pour un moment intime te tente-t-elle ?",
    category: "SPICY",
    intensity: 4,
    format: "STANDARD",
  },
];

export default function PreviewCards() {
  const [index, setIndex] = useState(0);
  const [flipped, setFlipped] = useState(false);
  const [answer, setAnswer] = useState(null);
  const question = useMemo(() => PREVIEW_QUESTIONS[index], [index]);

  const changeCard = (direction) => {
    const next = (index + direction + PREVIEW_QUESTIONS.length) % PREVIEW_QUESTIONS.length;
    setIndex(next);
    setFlipped(false);
    setAnswer(null);
  };

  const reset = () => {
    setFlipped(false);
    setAnswer(null);
  };

  return (
    <PageWrapper>
      <div className="cards-view preview-cards-view" data-testid="preview-cards-view">
        <p className="page-eyebrow">Mode aperçu</p>
        <h1 className="page-title">Aperçu des cartes</h1>
        <p className="page-note">
          Aucun clic ici n'enregistre de réponse et cette page ne touche pas à la session en cours.
        </p>

        <div className="cards-progress">
          Aperçu {index + 1} / {PREVIEW_QUESTIONS.length}
        </div>

        <div className="card-stage">
          <QuestionCard question={question} flipped={flipped} onFlip={() => setFlipped(true)} />
        </div>

        <div className="answer-slot">
          {flipped && (
            <AnswerButtons
              question={question}
              onAnswer={setAnswer}
              current={answer}
              disabled={false}
            />
          )}
        </div>

        <div
          style={{
            width: "100%",
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: 10,
            marginTop: 10,
          }}
        >
          <button className="btn-primary" type="button" onClick={() => changeCard(-1)} aria-label="Carte précédente">
            <ChevronLeft size={18} />
          </button>
          <button className="btn-primary" type="button" onClick={reset} aria-label="Retourner la carte">
            <RotateCcw size={17} />
          </button>
          <button className="btn-primary" type="button" onClick={() => changeCard(1)} aria-label="Carte suivante">
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
    </PageWrapper>
  );
}
